import setGlobalState from '../setGlobalState';
import store from '../../store';
import {reloadIframe} from '../../layout/myIframe/MyIframe';
import request from '../../library/request';
import {makeDirectApiCall} from '../../library/axios';
import {USER_API_PATH} from '../../config/config';

export const authRefreshToken = async () => {
    try {
        const isMaster = store.getState().user?.isMaster;
        const socket = store.getState().auth?.socket;
        
        // Use the direct API call method that completely bypasses interceptors
        const response = await makeDirectApiCall('post', `${USER_API_PATH}/refreshToken/`, {socket});
        const res = response.data;
        
        // Make the socket refresh call - this is a separate operation that doesn't cause the loop
        request('auth.refreshSocket', 'post', '/user/refreshSocket/', {socket})
            .catch(console.error);

        if(res.exp) {
            localStorage.setItem('exp', res.exp.toString());
            setGlobalState('auth.exp', res.exp.toString());
            if(isMaster){
                reloadIframe();
            }
        }
        if(res.csrfToken) {
            localStorage.setItem('csrfToken', JSON.stringify(res.csrfToken));
            setGlobalState('auth.csrfToken', res.csrfToken.toString());
        }
        return res;
    } catch (error) {
        console.error('Error refreshing token:', error);
        throw error;
    }
};

export const authRefreshTokenApplication = async () => {
    // Use the direct API call for this function as well
    try {
        const response = await makeDirectApiCall('post', `${USER_API_PATH}/refreshTokenApplication/`, {});
        const res = response.data;
        
        if(res.applicationExp) {
            localStorage.setItem('applicationExp', res.applicationExp.toString());
            setGlobalState('auth.applicationExp', res.applicationExp.toString());
        }
        if(res.applicationToken){
            return res.applicationToken;
        }
        return null;
    } catch (error) {
        console.error('Error refreshing application token:', error);
        return null;
    }
};
